<script lang="ts">
  interface Props {
    title: string;
    message: string;
  }

  const { title, message }: Props = $props();
</script>

<div class="empty-state" role="status">
  <strong>{title}</strong>
  <span>{message}</span>
</div>

<style>
  .empty-state {
    display: grid;
    gap: 0.35rem;
    padding: 3rem 1rem;
    color: var(--muted);
    text-align: center;
  }
  .empty-state strong {
    color: var(--cream);
  }
</style>
